import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import getPlan from "../../store/plan/actions/getPlan";
import { SeoRenderer } from "../../../common/helpers/seo";

import ChristmasTuning from "./ChristmasTuning";
import { seoImageUrl } from "./utils";

export default {
    component: connect(null, { getPlan })(injectIntl(ChristmasTuning)),
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({
            title: allMessage["christmas.title"],
            description: allMessage["christmas.seo"],
            image: seoImageUrl,
            allMessage,
            lang,
        });
    },
};
